import React from "react";
import { CheckCircle2, FileText, Clock, XCircle } from "lucide-react";

const STATUS_META = {
    draft: {
        label: "Draft",
        icon: FileText,
        className: "bg-slate-100 text-slate-700 border-slate-200",
    },
    in_review: {
        label: "In review",
        icon: Clock,
        className: "bg-amber-100 text-amber-800 border-amber-200",
    },
    approved: {
        label: "Approved",
        icon: CheckCircle2,
        className: "bg-green-100 text-green-800 border-green-200",
    },
    rejected: {
        label: "Rejected",
        icon: XCircle,
        className: "bg-red-100 text-red-800 border-red-200",
    },
};

const BirpStatusBadge = ({ status }) => {
    const meta = STATUS_META[status] || STATUS_META.draft;
    const Icon = meta.icon;
    return (
        <span
            data-testid={`birp-status-${status}`}
            className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${meta.className}`}
        >
            <Icon className="h-3 w-3" />
            {meta.label}
        </span>
    );
};

export default BirpStatusBadge;
